import { render, staticRenderFns } from "./MapPageFooter.vue?vue&type=template&id=0a4d3f28&scoped=true&"
import script from "./MapPageFooter.vue?vue&type=script&lang=js&"
export * from "./MapPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./MapPageFooter.vue?vue&type=style&index=0&id=0a4d3f28&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d3f28",
  null
  
)

export default component.exports